"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _react = _interopRequireWildcard(require("react"));
var _xstate = require("xstate");
var _propTypes = require("prop-types");
var _styles = require("./styles");
var _styles2 = require("../../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SingleChoiceButtons = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var _context;
  let {
    step,
    onChange,
    templateVariables
  } = _ref;
  const {
    control,
    question,
    answer = '',
    id
  } = step;
  const {
    options = []
  } = control;
  return /*#__PURE__*/_react.default.createElement(_styles2.ControlContainer, {
    "data-testid": "GxControl__SingleChoiceButtons",
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_styles2.Question, {
    id: `gx-question-${id}-question`,
    content: question,
    replacement: templateVariables
  }), /*#__PURE__*/_react.default.createElement(_styles.RadioButton, {
    name: `gx-question-${id}`,
    options: (0, _map.default)(_context = (0, _filter.default)(options).call(options, _ref2 => {
      let {
        label,
        value
      } = _ref2;
      return value && label;
    })).call(_context, _ref3 => {
      let {
        label,
        value,
        ariaDescription
      } = _ref3;
      const optionId = `gx-question-${id}-question-${value}`;
      return {
        label,
        value,
        ariaDescribedby: optionId,
        description: /*#__PURE__*/_react.default.createElement(_styles.VisuallyHiddenDescription, {
          id: optionId
        }, ariaDescription)
      };
    }),
    selected: answer,
    mode: "buttons",
    buttonStyle: "primary",
    row: true,
    onChange: (_event, value) => onChange({
      step,
      value
    }),
    "aria-describedby": `gx-question-${id}-question`
  }));
});
SingleChoiceButtons.displayName = 'SingleChoiceButtons';
SingleChoiceButtons.propTypes = {
  currentState: (0, _propTypes.instanceOf)(_xstate.State).isRequired,
  onChange: _propTypes.func.isRequired,
  step: (0, _propTypes.shape)({
    id: _propTypes.number.isRequired,
    question: _propTypes.string.isRequired,
    control: (0, _propTypes.shape)({
      label: _propTypes.string.isRequired,
      isRequired: _propTypes.bool,
      isRequiredMsg: _propTypes.string,
      options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
        label: _propTypes.string,
        value: _propTypes.string,
        ariaDescription: _propTypes.string
      })).isRequired
    }).isRequired,
    answer: _propTypes.string
  }),
  templateVariables: _propTypes.object
};
var _default = exports.default = SingleChoiceButtons;
SingleChoiceButtons.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SingleChoiceButtons",
  "props": {
    "currentState": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "State"
      },
      "required": true
    },
    "onChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "step": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "id": {
            "name": "number",
            "required": true
          },
          "question": {
            "name": "string",
            "required": true
          },
          "control": {
            "name": "shape",
            "value": {
              "label": {
                "name": "string",
                "required": true
              },
              "isRequired": {
                "name": "bool",
                "required": false
              },
              "isRequiredMsg": {
                "name": "string",
                "required": false
              },
              "options": {
                "name": "arrayOf",
                "value": {
                  "name": "shape",
                  "value": {
                    "label": {
                      "name": "string",
                      "required": false
                    },
                    "value": {
                      "name": "string",
                      "required": false
                    },
                    "ariaDescription": {
                      "name": "string",
                      "required": false
                    }
                  }
                },
                "required": true
              }
            },
            "required": true
          },
          "answer": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "templateVariables": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    }
  }
};